import { render, staticRenderFns } from "./goodsCategoryList.vue?vue&type=template&id=2a5b00da"
import script from "./goodsCategoryList.vue?vue&type=script&lang=js"
export * from "./goodsCategoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports